import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';
import { liveSessions } from '@/mocks/lives';
import SectionHeading from '@/components/feature/SectionHeading';

export default function CategorySection() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="container-page">
        <SectionHeading
          eyebrow="主题分类"
          title="八个直播方向，按兴趣直接进栏目"
          desc="每个栏目下的场次独立成表，包含当日排期、即将开始场次和往期回放。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((item) => {
            const count = liveSessions.filter((session) => session.category === item.key).length;
            return (
              <Link
                key={item.key}
                to="/schedule"
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <h3 className="mt-3.5 font-heading text-base font-bold text-foreground-950">{item.key}</h3>
                <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                <p className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>今日 {count} 场</span>
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}